import { Form as InertiaForm } from '@inertiajs/react'
import { type ComponentProps, useEffect, useState } from 'react'

import { CommunityType } from './types'
import {Input} from "@/components/ui/input.tsx";
import {Label} from "@/components/ui/label.tsx";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/components/ui/select.tsx";
import {Button} from "@/components/ui/button.tsx";

type FormProps = Omit<ComponentProps<typeof InertiaForm>, 'children'> & {
  community: CommunityType
  submitText: string
}

const statusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
] as const

export default function Form({ community, submitText, ...formProps }: FormProps) {
  const initialStatus = community.status === 1 ? 'inactive' : 'active'
  const [status, setStatus] = useState(initialStatus)

  useEffect(() => {
    setStatus(initialStatus)
  }, [initialStatus])

  return (
    <InertiaForm
      transform={data => ({ community: data })}
      className="dark"
      {...formProps}
    >
      {({ errors, processing }) => (
        <>
          <div className="my-5">
            <Label htmlFor="name">Nom de la commune</Label>
            <Input
                placeholder={"Nom de la commune"}
              type="text"
              name="name"
              id="name"
              defaultValue={community.name}
            />
            {errors.name && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.name.join(', ')}
              </div>
            )}
          </div>

          <div className="my-5">
            <Label htmlFor="location">Localité</Label>
            <Input
              type="text"
              name="location"
              placeholder={"Localité"}
              id="location"
              defaultValue={community.location}
            />
            {errors.location && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.location.join(', ')}
              </div>
            )}
          </div>

          <div className="my-5">
            <Label htmlFor="mayor">Nom du maire</Label>
            <Input
              type="text"
              name="mayor"
              id="mayor"
              placeholder={"Nom du maire"}
              defaultValue={community.mayor}
            />
            {errors.mayor && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.mayor.join(', ')}
              </div>
            )}
          </div>

          <div className="my-5">
            <Label htmlFor="phone">Numéro de téléphone</Label>
            <Input
              type="text"
              name="phone"
              id="phone"
              placeholder={"Numéro de téléphone"}
              defaultValue={community.phone}
            />
            {errors.phone && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.phone.join(', ')}
              </div>
            )}
          </div>

          <div className="my-5">
            <Label htmlFor="email">Adresse mail</Label>
            <Input
              type="text"
              name="email"
              id="email"
              placeholder={"Adresse mail"}
              defaultValue={community.email}
            />
            {errors.email && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.email.join(', ')}
              </div>
            )}
          </div>

          <div className="grid grid-cols-2 gap-4">

            <div className="my-5">
              <Label htmlFor="latitude">Latitude</Label>
              <Input
                  type="number"
                  name="latitude"
                  id="latitude"
                  defaultValue={community.latitude}
                  placeholder={"Latitude"}
              />
              {errors.latitude && (
                  <div className="text-red-500 px-3 py-2 font-medium">
                    {errors.latitude.join(', ')}
                  </div>
              )}
            </div>

            <div className="my-5">
              <Label htmlFor="longitude">Longitude</Label>
              <Input
                  type="number"
                  name="longitude"
                  id="longitude"
                  defaultValue={community.longitude}
                  placeholder={"Longitude"}
              />
              {errors.longitude && (
                  <div className="text-red-500 px-3 py-2 font-medium">
                    {errors.longitude.join(', ')}
                  </div>
              )}
            </div>
          </div>


          <div className="my-5">
            <Label htmlFor="status">Status</Label>
            <input type="hidden" name="status" value={status} />
            <Select value={status} onValueChange={setStatus}>
              <SelectTrigger className="w-full text-foreground">
                <SelectValue placeholder="Status" className={"text-foreground dark"}/>
              </SelectTrigger>
            <SelectContent className={"dark text-foreground"}>
              {statusOptions.map(option => (
                <SelectItem className={"text-foreground dark"} key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
            </Select>
            {errors.status && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.status.join(', ')}
              </div>
            )}
          </div>

          <div className="inline">
            <Button
              type="submit"
              disabled={processing}
              className=" cursor-pointer"
            >
              {submitText}
            </Button>
          </div>
        </>
      )}
    </InertiaForm>
  )
}
